import { AnimatePresence, motion } from 'framer-motion';

export default function Accordion({
  open,
  children,
  className,
  duration,
  initial,
  initialHeight,
}: {
  open: boolean;
  children: any;
  className?: string;
  duration?: number;
  initial?: boolean;
  initialHeight?: number;
}) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          key="content"
          animate="open"
          className={className}
          exit="collapsed"
          initial="collapsed"
          transition={{ duration: duration || 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
          variants={{
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 1, height: initialHeight != null ? initialHeight : 0 },
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
